import React from 'react';
import DeleteButton from '../containers/DeleteButton';
import CancelButton from './CancelButton';
import SaveButton from './SaveButton';

const EditControls = props => (
  <div className="u-bg-white u-position-relative">
    <div className="c-separator u-mv" />
    <div className="u-text-right u-mh u-pb">
      <DeleteButton {...props} />
      <CancelButton {...props} />
      <SaveButton {...props} />
    </div>
  </div>
);

export default EditControls;
